<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="60vh"
			@selection-change="handleSelectionChange"
		>
			<el-table-column type="selection" width="55"> </el-table-column>

			<el-table-column prop="id" label="id" width="80px"> </el-table-column>
			<el-table-column prop="title" label="活动名称"> </el-table-column>
			<el-table-column label="类型">
				<template slot-scope="scope">
					<span v-if="scope.row.type == 5">线上活动</span>
					<span v-if="scope.row.type == 6">线下活动</span>
				</template>
			</el-table-column>
			<el-table-column label="活动类型" width="100">
				<template slot-scope="scope">
					<span v-if="scope.row.event_category === 'ai'">AI</span>
					<span v-else-if="scope.row.event_category === 'web3'">Web3</span>
					<span v-else>未分类</span>
				</template>
			</el-table-column>

			<el-table-column prop="start_time" label="活动开始时间">
			</el-table-column>
			<el-table-column prop="end_time" label="活动结束时间"></el-table-column>
			<el-table-column label="显示首页">
				<template slot-scope="scope">
					<span v-if="scope.row.is_banner == 1">显示</span>
					<span v-if="scope.row.is_banner == 0">不显示</span>
				</template>
			</el-table-column>
			<el-table-column label="活动状态">
				<template slot-scope="scope">
					<span v-if="scope.row.activity_status === 'draft'">草稿</span>
					<span v-else-if="scope.row.activity_status === 'not_started'">未开始</span>
					<span v-else-if="scope.row.activity_status === 'ongoing'">进行中</span>
					<span v-else-if="scope.row.activity_status === 'ended'">已结束</span>
					<span v-else-if="scope.row.activity_status === 'review_rejected'">审核未通过</span>
					<span v-else-if="scope.row.activity_status === 'reviewing'">审核中</span>
					<span v-else>-</span>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="190">
				<template slot-scope="scope">
					<span
						v-if="scope.row.activity_status === 'draft'"
						class="pointer margin_left_10 action-primary"
						@click="changePublishStatus(scope.row, 'publish')"
						>发布</span
					>
					<span
						v-else-if="['not_started', 'ongoing', 'ended'].includes(scope.row.activity_status)"
						class="pointer margin_left_10 action-primary"
						@click="changePublishStatus(scope.row, 'draft')"
						>撤回草稿</span
					>
					<span class="pointer margin_left_10" @click="toEdit(scope.row)"
						>编辑</span
					>
					<span class="pointer margin_left_10" @click="toDelete(scope.row)"
						>删除</span
					>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import {
	changeActivityPublishStatusV2,
	destroyActivityV2,
	getActivityCollectionCountV2,
} from "@/api/article";

export default {
	props: ["tableData"],
	components: {},
	name: "",
	data() {
		return {
			value: true,
			title: "",
		};
	},
	methods: {
		toEdit(row) {
			this.$router.push({
				path: "/event/addevent",
				query: { id: row.id },
			});
		},
		changePublishStatus(row, action) {
			const isPublish = action === "publish";
			const message = isPublish
				? "确认发布该活动吗？发布后将直接在前台展示。"
				: "确认将该活动撤回为草稿吗？撤回后该活动将不再在前台展示。";
			this.$confirm(message, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					changeActivityPublishStatusV2({ id: row.id, action }).then((res) => {
						if (res.code == 200) {
							this.$message.success(isPublish ? "发布成功" : "已撤回草稿");
							this.$emit("refresh");
						}
					});
				})
				.catch(() => {});
		},
		async toDelete(row) {
			const res = await getActivityCollectionCountV2({ id: row.id });
			if (res.code !== 200) return;
			const count = Number((res.data && res.data.count) || 0);
			const message = count > 0
				? `该活动已加入 ${count} 个活动合集，删除后将同时从相关合集中移除。确认删除吗？`
				: "确认删除该活动吗？删除后无法恢复。";
			this.$confirm(message, "提示", {
				confirmButtonText: "确定删除",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				destroyActivityV2({ id: row.id }).then((result) => {
					if (result.code === 200) {
						this.$message.success("删除成功");
						this.$emit("refresh");
					}
				});
			}).catch(() => {});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
	},
};
</script>

<style scoped>
.action-primary { color: #409eff; }
</style>
